.embedded-review .user-short3 {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 5px;
  position: relative;
  min-height: 30px;
  line-height: 15px;
  color: #666560;
  font-family: 'Lato', sans-serif;
}
.embedded-review .user-short3 .left {
  width: 30px;
}
.embedded-review .user-short3 .right {
  margin-left: 20px;
}
.embedded-review .user-short3 .left {
  width: auto;
  position: relative;
}
.embedded-review .user-short3 .right {
  margin-left: 20px;
}
.embedded-review .user-short3 .username {
  font-weight: 700;
  color: #08090D;
  text-decoration: none;
}
.embedded-review .user-short3 .profession-info {
  font-weight: normal;
}
.embedded-review .review-title {
  font-size: 24px;
  font-weight: 900;
  margin: 10px 0;
  line-height: 1.4;
  color: #08090D;
  font-family: 'Lato', sans-serif;
}
.embedded-review .review-title a:hover {
  text-decoration: underline;
  color: #1f3949;
}
.embedded-review .review-title a.visited,
.embedded-review .review-title a {
  text-decoration: none;
  color: #08090D;
}
.embedded-review .review-body {
  margin: 35px 0;
  font-family: 'Martel', serif;
}
.embedded-review .review-body img {
  max-width: 100%;
}
.embedded-review .regular .review-body p:empty,
.embedded-review .regular .review-body p + br {
  display: none;
}
.embedded-review .regular .review-body p:empty + p {
  margin-top: 0;
}
.embedded-review .regular .review-body a {
  font-weight: bold;
  color: #2a8ecf !important;
  text-decoration: none;
}
.embedded-review .regular .review-body a:hover {
  color: #0a4d78 !important;
  text-decoration: underline;
  text-decoration-thickness: 1px !important;
  text-decoration-color: #0a4d78 !important;
  text-underline-offset: 1px !important;
}
.embedded-review .tag-flag {
  position: relative;
  height: 16px;
  padding: 4px 0px 2px 12px;
  width: 105px;
  background-color: #FFD700;
  color: #08090D;
  font-size: 12px;
  line-height: 1.2;
  margin: 0px 0px 0px 30px;
  margin-left: auto;
  /* needed for flex right-aligning */
}
.embedded-review .tag-flag:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  border-color: #FFD700 #FFD700 #FFD700 transparent;
  border-style: solid;
  border-width: 11px;
  margin-left: -22px;
  display: inline-block;
}
@media (max-width: 812px) {
  .embedded-review .tag-flag {
    margin-left: auto;
    /* forces flex item to right align */
  }
}
.embedded-review .helpful-posting {
  margin-top: 20px;
  font-weight: 500;
  border: 1px solid #E5E6E1;
  padding: 15px;
  font-size: 16px;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}
.embedded-review .helpful-posting .helpful_text_and_button {
  display: inline;
  position: relative;
  margin-right: 5px;
}
.embedded-review .helpful-posting .helpful-like-button button {
  background-color: #FFD700;
  color: #08090D;
  font-size: 16px;
  padding: 0.5em 1.5em;
  letter-spacing: 0px;
}
.embedded-review .helpful-posting img.avatar_image {
  padding: 1px;
  margin-left: 8px;
  vertical-align: middle;
}
.embedded-review .helpful-posting span.helpful-text {
  position: relative;
  top: 2px;
  margin-right: 10px;
}
@media (max-width: 812px) {
  .embedded-review .helpful-posting {
    text-align: center;
  }
  .embedded-review .helpful-posting .helpful-like-button button {
    margin: 10px 0px;
  }
}
.embedded-review .helpful-posting span.yes form {
  display: inline-block;
}
.embedded-review .helpful-posting span.yes form input {
  appearance: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  position: relative;
  top: 8px;
  outline: 0;
  vertical-align: text-bottom;
  transform: scale(0.75);
}
@media (max-width: 323px) {
  .embedded-review .helpful-posting span.yes form input {
    transform: scale(0.65);
    margin-left: 0;
    margin-right: -6px;
  }
}
.embedded-review .helpful-posting .bubble {
  position: relative;
  margin-left: 13px;
  padding: 3px 0 0;
  width: 30px;
  display: inline-block;
  height: 30px;
  background: #FFFFFF;
  box-sizing: border-box;
  text-align: center;
  border: #000000 solid 2px;
  font-size: 18px;
  top: 0px;
}
@media (max-width: 323px) {
  .embedded-review .helpful-posting .bubble {
    transform: scale(0.75);
  }
}
.embedded-review .helpful-posting .bubble:after {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 5px 5px 5px 0;
  border-color: transparent #000000;
  display: block;
  width: 0;
  z-index: 0;
  left: -7px;
  top: 8px;
}
.embedded-review .helpful-posting .bubble:before {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 5px 5px 5px 0;
  border-color: transparent #FFFFFF;
  display: block;
  width: 0;
  z-index: 1;
  left: -4px;
  top: 8px;
}
.embedded-review .helpful-posting .helpful-like-button button {
  font-size: 14px;
}
.embedded-review .review-note {
  display: flex;
}
@media (max-width: 812px) {
  .embedded-review .review-note {
    flex-direction: column;
    align-items: flex-end;
  }
}
@media (min-width: 813px) {
  .embedded-review .review-note {
    justify-content: flex-end;
  }
}
.embedded-review .review-note a {
  color: #848484;
  margin-left: 15px;
}
.embedded-review .review-note a:hover {
  text-decoration: none;
  color: #666560;
}
.embedded-review .review-admin-links {
  cursor: pointer;
  position: relative;
  margin-left: 10px;
}
.embedded-review .review-admin-links .links {
  display: none;
  position: absolute;
  width: auto;
  background: white;
  border: 1px solid #F5F5F5;
  z-index: 99999999;
  border-radius: 5px;
  right: 0;
  padding: 0;
  color: #848484;
  text-align: left;
}
.embedded-review .review-admin-links .links i {
  padding-right: 8px;
}
.embedded-review .review-admin-links .links a,
.embedded-review .review-admin-links .links span {
  display: block;
  font-size: 13px;
  color: #848484;
  text-decoration: none;
  padding: 10px 15px;
  white-space: nowrap;
  border-bottom: 1px solid #F5F5F5;
}
.embedded-review .review-admin-links .links a:hover,
.embedded-review .review-admin-links .links span:hover {
  background-color: #F5F5F5;
}
.embedded-review .review-admin-links:hover .links {
  display: block;
}
.embedded-product-review1 {
  padding: 0;
  margin: 0;
}
.embedded-product-review1:last-child {
  margin-bottom: 20px;
}
.embedded-product-review1:first-child .review-info {
  border-top: 0px;
}
.embedded-product-review1 .top-product-info {
  border-top: 2px solid #4D4D4D;
  padding-top: 10px;
  display: flex;
}
.embedded-product-review1 .top-product-info .title1 {
  font-size: 20px;
}
.embedded-product-review1 .top-product-info .col {
  vertical-align: middle;
}
.embedded-product-review1 .top-product-info .colA {
  flex-shrink: 0;
}
@media (min-width: 813px) {
  .embedded-product-review1 .top-product-info .colA {
    width: 70px;
  }
}
@media (max-width: 812px) {
  .embedded-product-review1 .top-product-info .colA {
    width: 60px;
  }
}
.embedded-product-review1 .review-info {
  border-top: 1px solid #D7D7D7;
  padding: 25px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.embedded-product-review1 .review-left {
  font-family: 'Lato', sans-serif;
}
@media (min-width: 813px) {
  .embedded-product-review1 .review-left {
    flex: auto;
    margin: 0;
    width: 80px;
    overflow: auto;
    display: inline-block;
  }
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-left {
    display: none;
  }
}
.embedded-product-review1 .review-top {
  width: 100%;
}
.embedded-product-review1 .review-top .author-info {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .author-info {
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
.embedded-product-review1 .review-top .review-top-info {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .review-top-info {
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
.embedded-product-review1 .review-top .user-labels {
  display: inline-block;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .user-labels {
    order: 1;
  }
}
.embedded-product-review1 .review-top .product-rating {
  display: inline-block;
  padding-left: 15px;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .product-rating {
    order: 2;
  }
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .flex-break-mobile {
    order: 3;
  }
}
.embedded-product-review1 .review-top .review-date,
.embedded-product-review1 .review-top .share-review {
  display: inline-block;
  font-size: 12px;
  color: #666560;
  padding-top: 4px;
  font-family: 'Lato', sans-serif;
}
.embedded-product-review1 .review-top .review-date a,
.embedded-product-review1 .review-top .share-review a {
  color: #666560;
  margin-left: 10px;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .review-date,
  .embedded-product-review1 .review-top .share-review {
    order: 5;
    margin-top: 5px;
  }
}
.embedded-product-review1 .review-top .download-case-study {
  margin-left: 10px;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-top .download-case-study {
    order: 4;
    margin: 8px 0px 0px 0px;
  }
}
.embedded-product-review1 .review-right {
  flex: auto;
  display: inline-block;
  vertical-align: top;
}
@media (min-width: 813px) {
  .embedded-product-review1 .review-right {
    width: 75%;
  }
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-right {
    width: initial;
  }
}
.embedded-product-review1 .review-right .top-line {
  overflow: hidden;
}
.embedded-product-review1 .review-right .top-line .create-date {
  font-family: 'Lato', sans-serif;
  color: #666560;
  font-size: 14px;
}
.embedded-product-review1 .review-right .review-body {
  font-size: 15px;
  margin: 30px 0;
}
.embedded-product-review1 .review-right .review-body p:empty,
.embedded-product-review1 .review-right .review-body p + br {
  display: none;
}
.embedded-product-review1 .review-right .review-body p:empty + p {
  margin-top: 0;
}
.embedded-product-review1 .review-right .review-body .review-section-snippet {
  margin-bottom: 25px;
  text-align: left;
}
.embedded-product-review1 .review-right .review-body .review-section-snippet:last-child {
  margin-bottom: 0;
}
.embedded-product-review1 .review-right .review-body .teaser {
  margin-bottom: 10px;
  cursor: pointer;
  line-height: 1.7;
}
.embedded-product-review1 .review-right .review-body .teaser h4 {
  display: inline;
}
.embedded-product-review1 .review-right .review-body .fullcontent {
  display: none;
}
.embedded-product-review1 .review-right .review-body a {
  color: #2a8ecf !important;
  text-decoration: none;
  font-family: 'Lato', sans-serif;
}
.embedded-product-review1 .review-right .review-body a:hover {
  color: #0a4d78 !important;
  text-decoration: underline;
  text-decoration-thickness: 1px !important;
  text-decoration-color: #0a4d78 !important;
  text-underline-offset: 1px !important;
}
.embedded-product-review1 .review-content {
  flex-basis: 100%;
}
.embedded-product-review1 .read_all {
  font-weight: bold;
  margin-top: 5px;
}
.embedded-product-review1 .to-full-review {
  cursor: pointer;
  font-weight: bold;
  color: #36627F;
  font-size: 17px;
}
.embedded-product-review1 h3 {
  font-family: 'Lato', sans-serif;
  color: #08090D;
  font-weight: 900;
}
@media (min-width: 813px) {
  .embedded-product-review1 h3 {
    font-size: 24px;
  }
}
@media (max-width: 812px) {
  .embedded-product-review1 h3 {
    font-size: 20px;
  }
}
.embedded-product-review1 .comments-heading-line {
  margin: 0;
}
@media (max-width: 812px) {
  .embedded-product-review1 .iframe-video-container {
    text-align: center;
  }
}
.embedded-product-review1 table {
  border-collapse: collapse;
  border: 1px solid #D7D7D7;
}
.embedded-product-review1 table td {
  border: 1px solid #D7D7D7;
  padding: 10px;
}
.embedded-product-review1 table td p {
  margin-bottom: 0px;
}
.embedded-product-review1 .expander {
  line-height: 1.7;
  /* max-height = line-height (1.5) * # of lines - set var "show-lines" as element inline style */
  max-height: calc(var(--show-lines) * 1.7);
}
.embedded-product-review1 [class*="gitb-expander"].closed:before {
  text-align: center;
  bottom: 0px;
  height: 100px;
  width: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff 70%);
}
.embedded-product-review1 [class*="gitb-expander"].closed:after {
  margin: 0 auto;
  bottom: -3px;
  text-align: left;
}
.embedded-product-review1 [class*="gitb-expander"]:after {
  content: attr(data-which);
  width: auto;
  cursor: pointer;
  left: 0;
  font-weight: 700;
  background: white;
  font-size: 16px;
  font-family: 'Lato', sans-serif;
  color: #2a8ecf !important;
  text-decoration: none;
}
.embedded-product-review1 [class*="gitb-expander"]:after:hover {
  color: #0a4d78 !important;
  text-decoration: underline;
  text-decoration-thickness: 1px !important;
  text-decoration-color: #0a4d78 !important;
  text-underline-offset: 1px !important;
}
.embedded-product-review1 [class*="gitb-expander"]:hover:after {
  color: #0a4d78 !important;
  text-decoration: underline;
}
.embedded-product-review1 .helpful-posting {
  margin-top: 20px;
  font-weight: 500;
  border: 1px solid #E5E6E1;
  padding: 15px;
  font-size: 16px;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}
.embedded-product-review1 .helpful-posting .helpful_text_and_button {
  display: inline;
  position: relative;
  margin-right: 5px;
}
.embedded-product-review1 .helpful-posting .helpful-like-button button {
  background-color: #FFD700;
  color: #08090D;
  font-size: 16px;
  padding: 0.5em 1.5em;
  letter-spacing: 0px;
}
.embedded-product-review1 .helpful-posting img.avatar_image {
  padding: 1px;
  margin-left: 8px;
  vertical-align: middle;
}
.embedded-product-review1 .helpful-posting span.helpful-text {
  position: relative;
  top: 2px;
  margin-right: 10px;
}
@media (max-width: 812px) {
  .embedded-product-review1 .helpful-posting {
    text-align: center;
  }
  .embedded-product-review1 .helpful-posting .helpful-like-button button {
    margin: 10px 0px;
  }
}
.embedded-product-review1 .helpful-posting span.yes form {
  display: inline-block;
}
.embedded-product-review1 .helpful-posting span.yes form input {
  appearance: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  position: relative;
  top: 8px;
  outline: 0;
  vertical-align: text-bottom;
  transform: scale(0.75);
}
@media (max-width: 323px) {
  .embedded-product-review1 .helpful-posting span.yes form input {
    transform: scale(0.65);
    margin-left: 0;
    margin-right: -6px;
  }
}
.embedded-product-review1 .helpful-posting .bubble {
  position: relative;
  margin-left: 13px;
  padding: 3px 0 0;
  width: 30px;
  display: inline-block;
  height: 30px;
  background: #FFFFFF;
  box-sizing: border-box;
  text-align: center;
  border: #000000 solid 2px;
  font-size: 18px;
  top: 0px;
}
@media (max-width: 323px) {
  .embedded-product-review1 .helpful-posting .bubble {
    transform: scale(0.75);
  }
}
.embedded-product-review1 .helpful-posting .bubble:after {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 5px 5px 5px 0;
  border-color: transparent #000000;
  display: block;
  width: 0;
  z-index: 0;
  left: -7px;
  top: 8px;
}
.embedded-product-review1 .helpful-posting .bubble:before {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 5px 5px 5px 0;
  border-color: transparent #FFFFFF;
  display: block;
  width: 0;
  z-index: 1;
  left: -4px;
  top: 8px;
}
.embedded-product-review1 .helpful-posting .helpful-like-button button {
  font-size: 14px;
}
.embedded-product-review1 .review-note {
  display: flex;
}
@media (max-width: 812px) {
  .embedded-product-review1 .review-note {
    flex-direction: column;
    align-items: flex-end;
  }
}
@media (min-width: 813px) {
  .embedded-product-review1 .review-note {
    justify-content: flex-end;
  }
}
.embedded-product-review1 .review-note a {
  color: #848484;
  margin-left: 15px;
}
.embedded-product-review1 .review-note a:hover {
  text-decoration: none;
  color: #666560;
}
.embedded-product-review1 .review-admin-links {
  cursor: pointer;
  position: relative;
  margin-left: 10px;
}
.embedded-product-review1 .review-admin-links .links {
  display: none;
  position: absolute;
  width: auto;
  background: white;
  border: 1px solid #F5F5F5;
  z-index: 99999999;
  border-radius: 5px;
  right: 0;
  padding: 0;
  color: #848484;
  text-align: left;
}
.embedded-product-review1 .review-admin-links .links i {
  padding-right: 8px;
}
.embedded-product-review1 .review-admin-links .links a,
.embedded-product-review1 .review-admin-links .links span {
  display: block;
  font-size: 13px;
  color: #848484;
  text-decoration: none;
  padding: 10px 15px;
  white-space: nowrap;
  border-bottom: 1px solid #F5F5F5;
}
.embedded-product-review1 .review-admin-links .links a:hover,
.embedded-product-review1 .review-admin-links .links span:hover {
  background-color: #F5F5F5;
}
.embedded-product-review1 .review-admin-links:hover .links {
  display: block;
}
.user-short2 {
  margin-bottom: 5px;
  position: relative;
  min-height: 60px;
}
.user-short2 .left {
  width: 60px;
}
.user-short2 .right {
  margin-left: 20px;
}
.user-short2 .user2-top {
  margin: 20px 0;
  display: flex;
}
.user-short2 .user2-top .username {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  line-height: 1.2;
  font-weight: 700;
  color: #08090D;
  text-decoration: none;
}
.user-short2 .user2-top .right {
  position: relative;
  height: 100%;
}
.user-short2 .user2-top .right .user-label-line {
  position: absolute;
  left: 0;
  bottom: 0;
}
.user-short2 .user2-top .right .aa {
  line-height: 1.4em;
  font-size: 12px;
  min-height: 35px;
}
.user-short2 .user2-top.border-bottom {
  padding-bottom: 10px;
  margin-bottom: 5px;
  border-bottom: 1px solid #A9A9A9;
}
.user-short2 .user-skills.border-top {
  padding-top: 10px;
  margin-top: 5px;
  border-top: 1px solid #A9A9A9;
}
.user-short2 .link-as-button {
  width: 100%;
  padding-right: 0;
  background: #4D4D4D;
}
.user-short2 .contact {
  margin-bottom: 5px;
}
.user-short2 .user-label-line > * {
  margin-bottom: 5px;
}
.user-short2a .user2-top.border-bottom {
  height: auto;
  width: 80px;
  padding: 10px 0;
  margin-bottom: 10px;
}
.user-short2a .user2-bottom {
  font-size: 13px;
}
.user-short2a .user2-bottom div {
  margin-bottom: 5px;
}
.user-short2a .user2-bottom .username-line {
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  font-weight: 700;
}
.user-short2a .user2-bottom .username-line .username {
  display: inline-block;
}
.user-short2a .user2-bottom .user-professional-info {
  width: 82px;
  line-height: 1.35;
}
.comments-heading-line {
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-bottom: 10px;
}
.comments-heading-line:before {
  font-family: 'Font Awesome 7 Pro';
  font-weight: 900;
  content: "\f075";
  color: #70CACA;
  margin-right: 8px;
}
.comments-heading-line svg,
.comments-heading-line i {
  color: #70CACA;
  margin-right: 8px;
}
#gitb-rating-form-item {
  text-align: center;
  flex: 100% 0;
  margin-left: 30px;
  margin-right: 30px;
}
#gitb-rating-form-item .itcs-label {
  font-size: 18px;
  font-weight: bold;
}
#gitb-rating-form-item #rating-radio-buttons {
  display: flex;
  justify-content: space-between;
}
#gitb-rating-form-item #rating-radio-buttons input[type='radio'] {
  display: none;
}
#gitb-rating-form-item #rating-radio-buttons label {
  font-size: 13px;
  border-radius: 50%;
  border: 2px solid #77ae3e;
  color: #77ae3e;
  height: 30px;
  width: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
}
#gitb-rating-form-item #rating-radio-buttons input[type='radio']:checked + label {
  background: #70CACA;
  color: white;
}
#gitb-rating-form-item #gitb-rating-scale-label {
  display: flex;
  justify-content: space-between;
  font-size: 80%;
  color: #727272;
}
.review-options {
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
}
.review-options .review-options-card {
  border: 1px solid #ffffff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.23);
  padding: 20px 15px;
  text-align: center;
  border-radius: 8px;
  width: 39%;
  margin: 2%;
  padding: 3%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.review-options .review-options-card .link-without-marks:hover {
  color: #4D4D4D;
}
.review-options .review-options-card p {
  color: #848484;
  padding: 0 10px;
  font-family: 'Lato', sans-serif;
}
.review-options .review-options-card .icon {
  font-size: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
.review-options .review-options-card .icon i {
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  display: flex;
}
.review-options .review-options-card .icon.green {
  background-color: rgba(157, 196, 104, 0.25);
}
.review-options .review-options-card .icon.blue {
  background-color: rgba(74, 129, 212, 0.25);
}
.review-options .review-options-card:hover {
  border: 1px solid #D7D7D7;
}
@media (max-width: 812px) {
  .review-options .review-options-card {
    width: 90%;
    margin: 15px 5%;
  }
}
